/* ============================================================
   RYVA · Badge de descuento en tarjetas: "- $30.00" -> "AHORRA $30.00"
   (El formato "Saved amount" del tema imprime "- $importe"; aquí solo
    cambiamos el prefijo, en todas las tarjetas del sitio.)
   Cargado desde snippets/copy-toast.liquid (todo el sitio).
   i18n: el texto viene de window.RYVA_I18N (snippets/ryva-js-i18n.liquid).
   ============================================================ */
(function () {
  function RY(k, fb) {
    var d = window.RYVA_I18N;
    return (d && typeof d[k] === 'string' && d[k].length) ? d[k] : fb;
  }
  var PREFIX = RY('save_prefix', 'AHORRA ');

  function fix(el) {
    if (!el || el.getAttribute('data-ryva-ahorra') === '1') return;
    var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
    var m = t.match(/^-\s*(.+)$/);          // empieza con "-"
    if (m && m[1] && !/%$/.test(m[1])) {     // no tocar porcentajes
      el.textContent = PREFIX + m[1];
      el.setAttribute('data-ryva-ahorra', '1');
    }
  }

  function scan(root) {
    var list = (root || document).querySelectorAll('.p_badge.on_sale');
    Array.prototype.forEach.call(list, fix);
  }

  function start() {
    scan(document);
    try {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            if (n.matches && n.matches('.p_badge.on_sale')) fix(n);
            if (n.querySelectorAll) scan(n);
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();